module.exports = "pegasus_template/assets/social-card.png";